import {
    Box,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    designersReset,
    GetSingleDesigner,
    UpdateDesignerData,
} from "../../Redux/DesignerSlice/DesignerSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { Add, Delete } from "@mui/icons-material";
import { useParams } from "react-router-dom";

const EditDesigner = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { designer, isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.designers
    );
    const designerData = designer?.data || [];

    // const GetSingleDesigner = async () => {

    // }

    const handelResetData = () => {
        if (isSuccess) {
            toast.success("Designer created successfully");
            formik.values.name = "";
            formik.values.email = "";
            formik.values.phone = "";
            formik.values.plan_price = "";
            formik.values.structure_calculation_price = "";
        }
    };

    const formik = useFormik({
        initialValues: {
            name: " ",
            email: " ",
            phone: " ",
            plan_price: " ",
            structure_calculation_price: " ",
        },
        onSubmit: async (values) => {
            await dispatch(
                UpdateDesignerData({
                    ...values,
                    id: id,
                })
            );
            await handelResetData();
            await dispatch(designersReset());
        },
    });

    const FetchSingleDesigner = async () => {
        await dispatch(GetSingleDesigner(id));
        await dispatch(designersReset());
    };

    useEffect(() => {
        FetchSingleDesigner();
    }, []);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(designersReset());
            };
            reset();
        }
    }, [isError]);

    useEffect(() => {
        if (designerData) {
            formik.values.name = designerData?.name;
            formik.values.email = designerData?.email;
            formik.values.phone = designerData?.phone;
            formik.values.plan_price = designerData?.plan_price;
            formik.values.structure_calculation_price =
                designerData?.structure_calculation_price;
        }
    }, [designerData]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Edit Designer </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    required
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    required
                                    name="email"
                                    label="Email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.email &&
                                        Boolean(formik.errors.email)
                                    }
                                    helperText={
                                        formik.touched.email &&
                                        formik.errors.email
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="phone"
                                    required
                                    name="phone"
                                    label="Phone"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.phone &&
                                        Boolean(formik.errors.phone)
                                    }
                                    helperText={
                                        formik.touched.phone &&
                                        formik.errors.phone
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="plan_price"
                                    name="plan_price"
                                    required
                                    label="Plan Price"
                                    value={formik.values.plan_price}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.plan_price &&
                                        Boolean(formik.errors.plan_price)
                                    }
                                    helperText={
                                        formik.touched.plan_price &&
                                        formik.errors.plan_price
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="structure_calculation_price"
                                    name="structure_calculation_price"
                                    required
                                    label="Structure Calculation Price"
                                    value={
                                        formik.values
                                            .structure_calculation_price
                                    }
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched
                                            .structure_calculation_price &&
                                        Boolean(
                                            formik.errors
                                                .structure_calculation_price
                                        )
                                    }
                                    helperText={
                                        formik.touched
                                            .structure_calculation_price &&
                                        formik.errors
                                            .structure_calculation_price
                                    }
                                />
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Edit"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default EditDesigner;
